import script from "./CategorySlider.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorySlider.vue?vue&type=script&setup=true&lang=js"

import "./CategorySlider.vue?vue&type=style&index=0&id=742911be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-742911be"]])

export default __exports__